import { connect } from "react-redux";
import actionCreators from "./redux/actionCreators";
import { getInProgress, getSummaryReportId, getSummaryReportObjects } from "./redux/selectors";
import SummaryReportSidebarMenu from "./summaryReportSidebarMenu";
const mapStateToProps = (state) => ({
    summaryReportId: getSummaryReportId(state),
    data: getSummaryReportObjects(state),
    inProgress: getInProgress(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (summaryReportId) => dispatch(actionCreators.getSummaryReportObjects(summaryReportId))
});
export default connect(mapStateToProps, mapDispatchToProps)(SummaryReportSidebarMenu);
